import { render, staticRenderFns } from "./controlPage.vue?vue&type=template&id=40890ee3&"
import script from "./controlPage.vue?vue&type=script&lang=js&"
export * from "./controlPage.vue?vue&type=script&lang=js&"
import style0 from "./controlPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports